import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

// Pagination of the queue: total and pages. Hidden when everything fits in one page.
export default function Pagination({ pagina, tamanoPagina, total, disabled, onChange }) {
  const size = Math.max(1, Number(tamanoPagina) || 1);
  const pages = Math.max(1, Math.ceil((Number(total) || 0) / size));
  if (pages <= 1) return null;

  const current = Math.min(Math.max(1, Number(pagina) || 1), pages);
  const from = (current - 1) * size + 1;
  const to = Math.min(current * size, total);

  return (
    <nav className="crm-rollo__pagination" aria-label="Paginación de gestiones">
      <span className="crm-rollo__meta">{`Mostrando ${from}–${to} de ${total}`}</span>
      <div className="crm-rollo__pagination-controls">
        <button
          type="button"
          className="crm-rollo__btn crm-rollo__btn--secondary crm-rollo__btn--sm"
          disabled={disabled || current <= 1}
          onClick={() => onChange(current - 1)}
        >
          <FontAwesomeIcon icon={faChevronLeft} aria-hidden="true" />
          Anterior
        </button>
        <span className="crm-rollo__pagination-page">{`Página ${current} de ${pages}`}</span>
        <button
          type="button"
          className="crm-rollo__btn crm-rollo__btn--secondary crm-rollo__btn--sm"
          disabled={disabled || current >= pages}
          onClick={() => onChange(current + 1)}
        >
          Siguiente
          <FontAwesomeIcon icon={faChevronRight} aria-hidden="true" />
        </button>
      </div>
    </nav>
  );
}
